import { render, staticRenderFns } from "./FinancialProposalDemo.vue?vue&type=template&id=386fe4db"
import script from "./FinancialProposalDemo.vue?vue&type=script&lang=js"
export * from "./FinancialProposalDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports